import type { PageHeaderIdentityProps } from './PageHeader.types';

/**
 * Left-hand group naming the current page. Owns the gap between its parts so
 * no caller can drift from the spec; `min-w-0` is what lets a long title
 * truncate instead of pushing the action group off the header.
 */
export function PageHeaderIdentity(props: PageHeaderIdentityProps) {
  return (
    <div data-testid="page-header-identity" className="flex min-w-0 items-center gap-xs">
      {props.children}
    </div>
  );
}
